// Google Tag Manager utility functions
declare global {
  interface Window {
    dataLayer: any[]
  }
}

// Initialize dataLayer if it doesn't exist
if (typeof window !== "undefined") {
  window.dataLayer = window.dataLayer || []
}

// Generic GTM event tracking function
export const gtmEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...parameters,
    })
  }
}

// Specific event functions for common actions
export const trackFormSubmission = (formName: string, success = true) => {
  gtmEvent("form_submit", {
    form_name: formName,
    success: success,
    timestamp: new Date().toISOString(),
  })
}

export const trackPageView = (pageName: string) => {
  gtmEvent("page_view", {
    page_name: pageName,
    timestamp: new Date().toISOString(),
  })
}

export const trackButtonClick = (buttonName: string, location: string) => {
  gtmEvent("button_click", {
    button_name: buttonName,
    location: location,
    timestamp: new Date().toISOString(),
  })
}

export const trackServiceInterest = (serviceType: string) => {
  gtmEvent("service_interest", {
    service_type: serviceType,
    timestamp: new Date().toISOString(),
  })
}

export const trackContactMethod = (method: string) => {
  gtmEvent("contact_method", {
    method: method,
    timestamp: new Date().toISOString(),
  })
}
